// MeghivottEloadok component translations

export const MEGHIVOTT_ELOADOK_TRANSLATIONS = {
    hu: {
        esgTitle: "ESG 1.5 Oktatók",
        pageTitle: "11. Meghívott előadók és óraadók",
        
        section1: {
            title: "11.1. Főállású oktatók",
            titleA: "11.1.a AACSB akkreditáció esetében kérjük értékelje az oktatókat",
            descriptionA: "SA – Scholarly Academics / PA – Practice Academics /SP – Scholarly Practitioners /IP – Instructional Practitioners",
            
            titleB: "11.1.b ABET akkreditáció esetében kérjük értékelje az oktatókat",
            descriptionB: "T – Tenure / TT – Tenure Track /NTT - Non Tenure Track",
        },
        
        section2: {
            title: "11.2. Oktatói lefedettség",
            noteLabel: "Megjegyzés(opcionális):",
        },
        
        section3: {
            title: "11.3. Meghívott előadók és óraadók",
            question1: "A vizsgált félévben meghívott előadók és óraadók részvétele",
            question2: "Külső helyszíneken (cégeknél, intézményeknél) tartott órák",
            question3: "Vállalati/ipari üzemlátogatások",
            question4: "A vizsgált félévben külföldi vendégprofesszorok részvétele",
            question5: "Külföldi vendégprofesszorok száma",
            numberPlaceholder: "fő",
        },
        
        buttons: {
            previous: "Előző szakasz",
            next: "Következő szakasz",
            save: "Mentés",
            finalize: "Véglegesítés",
            unfinalize: "Véglegesítés visszavonása"
        },
        
        alerts: {
            requiredFields: "Minden szöveges mezőt ki kell tölteni!"
        },
        
        sidebar: [
            "Szak alapadatok",
            "A képzés",
            "A szak mintatanterve",
            "Tehetséges, kiemelkedő hallgatói teljesítmények",
            "Idegen nyelvi követelmények",
            "Kötelező szakmai gyakorlat",
            "Mintatanterv fejlesztések, módosítások",
            "Fejlesztési javaslatok",
            "Oktatás",
            "A szak hallgatóira vonatkozó adatok",
            "Versenytárs elemzés",
            "Meghívott előadók és óraadók",
            "Oktatók értékelése",
            "A képzés tanulmányi körülményei",
            "A szak kommunikációja",
            "Fejlesztési javaslatok megvalósítása és értékelése",
            "Szakjelentés lezárása"
        ]
    },
    
    en: {
        esgTitle: "ESG 1.5 Teaching Staff",
        pageTitle: "11. Guest Lecturers and Teachers",
        
        section1: {
            title: "11.1 Full-Time Academic Staff",
            titleA: "11.1.a For AACSB Accreditation. Please classify academic staff according to the following categories",
            descriptionA: "SA – Scholarly Academics / PA – Practice Academics / SP – Scholarly Practitioners / IP – Instructional Practitioners",
            
            titleB: "11.1.b For ABET Accreditation Please classify academic staff according to the following categories",
            descriptionB: "T – Tenured / TT – Tenure Track / NTT – Non-Tenure Track",
        },
        
        section2: {
            title: "11.2. Teaching Staff Coverage",
            noteLabel: "Comments (optional):",
        },
        
        section3: {
            title: "11.3. Visiting Lecturers and Adjunct Instructors",
            question1: "Participation of visiting lecturers and adjunct instructors during the reviewed semester",
            question2: "Classes delivered at external locations (companies, institutions)",
            question3: "Company / industry site visits",
            question4: "Participation of international visiting professors during the reviewed semester",
            question5: "Number of international visiting professors",
            numberPlaceholder: "persons",
        },
        
        buttons: {
            previous: "Previous section",
            next: "Next section",
            save: "Save",
            finalize: "Finalize",
            unfinalize: "Withdraw finalization"
        },
        
        alerts: {
            requiredFields: "All text fields must be filled!"
        },
        
        sidebar: [
            "Programme Basic Data",
            "The Programme",
            "Programme Curriculum",
            "Talented Students and Outstanding Student Performance",
            "Foreign Language Requirements",
            "Compulsory Professional Practice",
            "Curriculum Developments and Modifications",
            "Development Recommendations",
            "Teaching",
            "Data related to the major",
            "Competitor Analysis",
            "Guest Lecturers and Part-time Teachers",
            "Assessment of Teachers",
            "Study Conditions",
            "Programme Communication",
            "Implementation and Evaluation of Development Recommendations",
            "Finalisation of Programme Report"
        ]
    }
};
